import {
	createRouter,
	createWebHistory
} from 'vue-router'

const routes = [{
		path: '/',
		name: '',
		meta: {
			title: "登录",
		},
		component: () => import( /* 登录 */ '../views/login.vue'),
	},
	{
		path: '/register',
		name: 'register',
		meta: {
			title: "注册",
		},
		component: () => import( /* 注册 */ '../views/register.vue'),
	},
	{
		path: '/forgetpad',
		name: 'forgetpad',
		meta: {
			title: "忘记密码",
		},
		component: () => import( /* 忘记密码 */ '../views/forgetpad.vue'),
	},
	
	{
		path: '/index_commit',
		name: 'index_commit',
		meta: {
			title: "承诺书",
		},
		component: () => import( /* 承诺书 */ '../views/index/index_commit.vue'),
	},
	{
		path: '/layout',
		name: 'layout',
		component: () => import( /* 首页 */ '../views/layout'),
		children: [{
				path: '/index_list',
				name: 'index_list',
				component: () => import( /* 哈仲仲裁员申请表 */ '../views/index/index_list'),
			},
			{
				path: '/form_jbxx',
				name: 'form_jbxx',
				component: () => import( /* 个人基本信息 */ '../views/form/form_jbxx'),
			},
			{
				path: '/form_lxfs',
				name: 'form_lxfs',
				component: () => import( /* 联系方式 */ '../views/form/form_lxfs'),
			},
			{
				path: '/form_rztj',
				name: 'form_rztj',
				component: () => import( /* 仲裁员任职条件 */ '../views/form/form_rztj'),
			},
			{
				path: '/form_zybj',
				name: 'form_zybj',
				component: () => import( /* 专业背景 */ '../views/form/form_zybj'),
			},
			{
				path: '/form_jybj',
				name: 'form_jybj',
				component: () => import( /* 教育背景 */ '../views/form/form_jybj'),
			},
			{
				path: '/form_zyzs',
				name: 'form_zyzs',
				component: () => import( /* 各种专业知识 */ '../views/form/form_zyzs'),
			},
			{
				path: '/form_gzjl',
				name: 'form_gzjl',
				component: () => import( /* 工作经历 */ '../views/form/form_gzjl'),
			},
			{
				path: '/form_yjjy',
				name: 'form_yjjy',
				component: () => import( /* 意见建议 */ '../views/form/form_yjjy'),
			},
			{
				path: '/index_info',
				name: 'index_info',
				component: () => import( /* 个人信息 */ '../views/index/index_info'),
			},
			{
				path: '/index_contact',
				name: 'index_contact',
				component: () => import( /* 联系方式是 */ '../views/index/index_contact'),
			},
			{
				path: '/editpsd',
				name: 'editpsd',
				component: () => import( /* 修改密码 */ '../views/index/editpsd.vue'),
			},
			{
				path: '/editphone',
				name: 'editphone',
				component: () => import( /* 修改手机号 */ '../views/index/editphone.vue'),
			},
		]
	},

]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
  // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
});

export default router